var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLearningResourceEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8953 147.791C114.707 147.791 147.791 114.707 147.791 73.8955C147.791 33.0843 114.707 0 73.8953 0C33.0841 0 0 33.0843 0 73.8955C0 114.707 33.0841 147.791 73.8953 147.791Z",
    fill: "url(#paint0_linear_13153_5198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 113V49.3344L87.4184 35H46.069V113H102Z",
    fill: "#09172A",
    stroke: "#09172A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49.1724H87.8276V34L103 49.1724Z",
    fill: "#1B2B3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3452 49.1722H68.5176V51.9309H53.3452V49.1722Z",
    fill: "#FFC97A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3453 58.8278H94.7246V61.5864H53.3453V58.8278Z",
    fill: "#1B2B3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0703 68H84.0703V71H53.0703V68Z",
    fill: "#223446"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3453 78.1382H94.7246V80.8968H53.3453V78.1382Z",
    fill: "#1B2B3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0703 88H84.0703V91H53.0703V88Z",
    fill: "#223446"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3453 97.4485H94.7246V100.207H53.3453V97.4485Z",
    fill: "#1B2B3B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13153_5198",
    x1: 2.95582,
    y1: 3.10361,
    x2: 105.966,
    y2: 96.0639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525050",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLearningResourceEmptyImg);
export default __webpack_public_path__ + "static/media/darkLearningResourceEmptyImg.3c53ea178b9242052fd07c6e21367e58.svg";
export { ForwardRef as ReactComponent };